<mat-list>
  <mat-list-item class="mobile-actions__actions-header">
    <rav-icon
      matListIcon
      data-cy="cancel-actions"
      (click)="cancelClick.emit()"
      [name]="RavIcon.Cancel"
      class="mobile-actions__cancel-icon white-color cursor-pointer"
    ></rav-icon>
    <h3 matLine class="white-color">
      {{ selectedItems?.length }} element<span *ngIf="selectedItems?.length !== 1">s</span>
    </h3>
    <rav-icon
      matListIcon
      *ngFor="let action of actions"
      (click)="onActionIconClick(action)"
      [attr.data-cy]="'icon-' + action.mobileIcon"
      [name]="action.mobileIcon"
      [ngStyle]="{
        display: !scope.hasAccesses(action.scope) || !showAction(action) ? 'none' : 'inline'
      }"
      [class.mobile-actions__disabled-icon]="
        !TableActions.isEnabled(action, selectedItems) || action.disabled
      "
      class="mobile-actions__action-icon white-color cursor-pointer"
    ></rav-icon>
  </mat-list-item>
</mat-list>
